import React from 'react'
import aboutImage from '../../assets/images/performance.jpg'
import PageCreator from '../../components/PageCreator'
import strategicPlan from '../../assets/files/StrategicPlan2021.pdf'
import consumerSatisfactionTwenty from '../../assets/files/Consumer_Satisfaction_Results.pdf'
import consumerSatisfactionNineteen from '../../assets/files/2019Consumer_Satisfaction_Results.pdf'
import consumerAccessibility from '../../assets/files/Consumer_Accessibility2020.xlsx'
import adultStakeHoldersSurvey from '../../assets/files/AdultServicesStakeholdersSurvey.xlsx'
import ddSatisfactionSurvey from '../../assets/files/DDStakeholderSatisfactionSurvey.xlsx'
import publicPlan from '../../assets/files/Public_Strategic_Plan.pdf'
import strategicSurvey from '../../assets/files/Addiction_Stakeholders_Survey.pdf'
import '../../assets/scss/index.scss'

import {Container, Col, Row } from 'react-bootstrap'
export default function index() {
    return (
        <PageCreator imageName={aboutImage} opacityLevel='0.9'>
        <p className='mainFont' style={{ color: "#222222", fontSize: '1.5em', margin: '0' }}>Performance Measures</p>

        <hr style={{ backgroundColor: "#222222" }} />
        <Container>
            <Row>
                <Col>
                <ul>
                    {/* <li>
                    <a href={strategicPlan} target="_blank" rel="noopener noreferrer">2021 Strategic Plan</a>
                    </li> */}
                    <li><a href={publicPlan} target="_blank" rel="noopener noreferrer">2021 Public Strategic Plan</a></li>
                    <li><a href={strategicSurvey} target="_blank" rel="noopener noreferrer">Addiction Stakeholders Survey</a></li>
                    <li><a href={consumerSatisfactionTwenty} target="_blank" rel="noopener noreferrer">2020 Consumer Satisfaction Results</a></li>
                    <li><a href={consumerSatisfactionNineteen} target="_blank" rel="noopener noreferrer">2019 Consumer Satisfaction Results</a></li>
                    <li><a href={consumerAccessibility} target="_blank" rel="noopener noreferrer">2020 Consumer Accessibility</a></li>
                    <li><a href={adultStakeHoldersSurvey} target="_blank" rel="noopener noreferrer">Adult Services Stake Holders Survey</a></li>
                    <li><a href={ddSatisfactionSurvey} target="_blank" rel="noopener noreferrer">DD Satisfaction Survey</a></li>




                </ul>

                </Col>
            </Row>
        </Container>

    </PageCreator>
    )
}
